import { t } from "@/i18n-js/instance";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { IconButton } from "@circle-react-shared/uikit/HeaderV3/IconButton";
import { useBuilderStore } from "../Hooks/useBuilderStore";
import { useOnClickToggleSection } from "../Hooks/useOnClickToggleSection";
import type { ButtonProps } from "./Button";

export interface BlocksButtonProps extends ButtonProps {
  shouldKeepSidebarOpen?: boolean;
}

export const BlocksButton = ({
  shouldKeepSidebarOpen = false,
  className,
  ...rest
}: BlocksButtonProps) => {
  const onClickHandler = useOnClickToggleSection({
    viewName: "addBlocks",
    shouldKeepSidebarOpen,
  });
  const actionSidebarView = useBuilderStore(state => state.actionSidebarView);
  const isAddBlocksActive = actionSidebarView === "addBlocks";

  return (
    <IconButton
      name={
        isAddBlocksActive
          ? "24-builder-ui-sidebar-add-blocks-filled"
          : "24-builder-ui-sidebar-add-blocks"
      }
      iconSize={24}
      buttonSize={32}
      tooltipText={t("settings.site.pages.builder.blocks")}
      tooltipPosition="right"
      ariaLabel={t("add")}
      className={classNames(className, {
        "bg-tertiary": isAddBlocksActive,
      })}
      iconClassName="!text-dark"
      onClick={onClickHandler}
      data-testid="builder-ui-add-blocks-button"
      {...rest}
    />
  );
};
